import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  FormGroupInput,
  TextInput,
  RadioInput,
  SelectInput,
} from "../../components";
import { hasErrorInput } from "../../utils";
import HintIconToolTip from "../../components/HintIconToolTip";

function ApprovalStatus({ onSubmit, settings, onSettingChange, errors }) {
  const timeUnits = [
    { value: "hours", label: "時間" },
    { value: "days", label: "日" },
    { value: "months", label: "ヶ月" },
    { value: "years", label: "年" },
  ];
  const inputPossible = {
    hours: 24,
    days: 31,
    months: 12,
    years: 10,
  };
  const handleChangeBunchApprove = (e, value) => {
    onSettingChange(e.target.name, value);
  };
  const handleChangeEditTime = (e) => {
    onSettingChange(e.target.name, e.target.value);
  };
  const handleChangeTimeUnit = (e) => {
    onSettingChange("approval_time_unit", e.target.value);
  };

  return (
    <div
      className={`bg-white px-[30px] py-[15px] pb-5 lg:px-[60px] lg:pt-[30px] lg:pb-10 w-[640px] lg:w-[820px] border border-tenken-gray-300 rounded-lg`}
      role="tabpanel"
    >
      <h4 className="text-tenken-tablet-heading-4 lg:text-tenken-heading-4 font-bold text-center">
        承認状況画面
      </h4>
      <h5 className="mt-2.5 lg:text-tenken-body font-light text-center">
        NG 項目が存在する場合の一括判定ボタンの動作方法を選択してください
      </h5>
      <div className="mt-[30px] lg:mt-10 flex border border-tenken-gray-250">
        <div className="bg-tenken-gray-070 w-[168px] lg:w-[240px] border-r border-tenken-gray-250 py-2 px-2 lg:py-4 lg:px-4">
          <div className="py-4 flex">
            <label>設定方法</label>
            <div className="lg:ml-2 ml-1 lg:mt-[2px]">
              <HintIconToolTip>
                <h4>■一括承認設定</h4>
                <p>点検結果にNG箇所があった点検表を、</p>
                <p>一括承認の対象に含めるか、</p>
                <p>含めないかの設定を行います</p>
              </HintIconToolTip>
            </div>
          </div>
        </div>
        <div className="py-2 px-3 lg:py-4 lg:px-6 flex items-center lg:w-[460px]">
          <div className="py-2">
            <div className="flex space-x-9">
              <RadioInput
                name="bulk_approval_ng_items"
                id="approvable"
                onChange={(e) => handleChangeBunchApprove(e, true)}
                checked={settings.bulk_approval_ng_items}
                label="承認可能"
              />
              <RadioInput
                name="bulk_approval_ng_items"
                id="not-approvable"
                onChange={(e) => handleChangeBunchApprove(e, false)}
                checked={!settings.bulk_approval_ng_items}
                label="承認不可能"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-x border-b border-tenken-gray-250">
        <div className="bg-tenken-gray-070 w-[168px] lg:w-[240px] border-r border-tenken-gray-250 py-2 px-2 lg:py-4 lg:px-4">
          <div className="py-4">
            <label>未承認通知更新間隔</label>
          </div>
        </div>
        <div className="py-1.5 px-5 lg:w-[460px] space-y-2">
          <p>未承認の点検を通知する間隔を入力してください</p>
          <FormGroupInput>
            <TextInput
              className="max-w-[80px]"
              name="unapproved_notification_interval_time"
              onChange={handleChangeEditTime}
              maxLength={5}
              pattern="[0-9]*"
              value={settings.unapproved_notification_interval_time || ""}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              hasError={hasErrorInput(
                errors,
                `unapproved_notification_interval_time`
              )}
            />
            <span className="flex items-center ml-2">分ごと</span>
          </FormGroupInput>
        </div>
      </div>
      <div className="flex border-x border-b border-tenken-gray-250">
        <div className="bg-tenken-gray-070 w-[168px] lg:w-[240px] border-r border-tenken-gray-250 py-2 px-2 lg:py-4 lg:px-4">
          <div className="py-4 flex">
            <label>全一括承認の範囲</label>
            <div className="lg:ml-2 ml-1 lg:mt-[2px]">
              <HintIconToolTip>
                <h4>■アーカイブ期間</h4>
                <p>システムがデータをアーカイブ化するまで</p>
                <p>の期間です。</p>
                <p>システムは点検データと関連するデータを</p>
                <p>一定期間経過後(*1)にアーカイブ化します。</p>
                <p>※1　システムは毎日0時0分にアーカイブ</p>
                <p>化要否を判定します。</p>
                <p>アーカイブ化するまでの期間は右側の項目で</p>
                <p>指定可能です。</p>
              </HintIconToolTip>
            </div>
          </div>
        </div>
        <div className="py-6 px-5 lg:w-[460px]">
          <FormGroupInput className="space-x-2">
            <span className="flex items-center">点検後</span>
            <TextInput
              className="max-w-[60px]"
              name="approval_time_value"
              onChange={handleChangeEditTime}
              maxLength={2}
              pattern="[0-9]*"
              value={settings.approval_time_value || ""}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              hasError={hasErrorInput(errors, `approval_time_value`)}
            />
            <SelectInput
              className="w-[80px]"
              value={settings.approval_time_unit}
              options={timeUnits}
              hasError={hasErrorInput(errors, "approval_time_unit")}
              onChange={handleChangeTimeUnit}
            />
            <span className="flex items-center">
              入力可能：1～{inputPossible[settings.approval_time_unit] || 31}
            </span>
          </FormGroupInput>
        </div>
      </div>
      <div className="mt-10 flex justify-center">
        <Button
          color="yellow"
          className="min-w-[220px]"
          onClick={onSubmit}
          id="btn-setting-update"
        >
          更新
        </Button>
      </div>
    </div>
  );
}

ApprovalStatus.propTypes = {
  show: PropTypes.bool,
};

export default ApprovalStatus;
